import React from 'react';
import { Clock3Icon, ShoppingBasketIcon, UtensilsIcon, WalletCardsIcon, BoxIcon } from 'lucide-react';
const pains = [{
  icon: Clock3Icon,
  text: 'Llegas cansado(a) y cocinar se ha convertido en otra obligación.'
}, {
  icon: BoxIcon,
  text: 'Cada día vuelves a preguntarte: “¿Qué cocino hoy?”'
}, {
  icon: ShoppingBasketIcon,
  text: 'Desperdicias alimentos porque se echan a perder.'
}, {
  icon: UtensilsIcon,
  text: 'Intentas comer saludable, pero terminas recurriendo a comida rápida.'
}, {
  icon: WalletCardsIcon,
  text: 'Gastas de más en el supermercado y pierdes tiempo cocinando a diario.'
}];
export function ProblemSection() {
  return <section id="para-ti" className="bg-[#143827] px-5 py-16 text-[#fffaf0] sm:px-8 sm:py-24" data-id="element-142" data-mp="3ei0i4fnb900b">
      <div className="mx-auto grid max-w-7xl gap-10 lg:grid-cols-[0.85fr_1.15fr] lg:gap-20" data-id="element-143" data-mp="1p2u2gxtn43kv">
        <div data-id="element-144" data-mp="1k49blp0a2w93">
          <p className="text-sm font-bold uppercase tracking-[0.16em] text-[#c5dfbb]" data-id="element-145" data-mp="1k4iuksmwo35a">
            ¿Te resulta familiar?
          </p>
          <h2 className="font-display mt-4 text-4xl font-black leading-[0.98] tracking-[-0.045em] sm:text-5xl" data-id="element-146" data-mp="oc7wremuy9hr">
            😮‍💨 Tu agenda ya está llena. Tus comidas no deberían complicarla más.
          </h2>
          <p className="mt-5 max-w-md text-lg leading-relaxed text-[#d3e0d4]" data-id="element-147" data-mp="x49v97dd9fpe">
            Meal Prep Club está pensado para personas con una rutina ocupada que
            quieren volver a sentirse en control de su semana.
          </p>
        </div>
        <ul className="grid gap-3 sm:grid-cols-2" role="list" data-id="element-148" data-mp="1714qnhecezzg">
          {pains.map(({
          icon: Icon,
          text
        }) => <li key={text} className="flex gap-4 rounded-2xl border border-[#37664d] bg-[#1b4631] p-5" data-id="element-149" data-mp="1bzoddk0rgfsv">
              <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-[#a92d3d] text-white" data-id="element-150" data-mp="3dtxffv6r58cb">
                <Icon aria-hidden="true" className="h-5 w-5" data-id="element-151" data-mp="3hvip77nzp6ia" />
              </span>
              <p className="pt-1 text-sm leading-relaxed text-[#edf3e7]" data-id="element-152" data-mp="ozh78lotvkqw">
                {text}
              </p>
            </li>)}
        </ul>
      </div>
    </section>;
}